import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function VapingStartAgePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.vapingStartAge.heading')}
      buttons={[
        {
          text: t('pages.onboarding.vapingStartAge.options.teenager'),
          value: 'teenager',
        },
        {
          text: t('pages.onboarding.vapingStartAge.options.young-adult'),
          value: 'young-adult',
        },
        {
          text: t('pages.onboarding.vapingStartAge.options.adult'),
          value: 'adult',
        },
        {
          text: t('pages.onboarding.vapingStartAge.options.later-in-life'),
          value: 'later-in-life',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
